import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { DestinationPageLink } from 'models';

import { UitkCardTextSegment } from 'uitk-react-cards';
import { UitkLink } from 'uitk-react-link';

const TrackingLink = ClickTracker(UitkLink);

interface LocationEditorialProps {
  body: string;
  neighborhoodTitle: string;
  destinationPageLink?: DestinationPageLink;
}

export const LocationEditorial: React.FunctionComponent<LocationEditorialProps> = ({ body, neighborhoodTitle, destinationPageLink }) => {
  if (!body && !neighborhoodTitle) {
    return null;
  }

  const destinationPageLinkUrl = destinationPageLink && destinationPageLink.url;
  const destinationPageLinkText = destinationPageLink && destinationPageLink.text;

  return (
    <React.Fragment>
      <UitkCardTextSegment className="whats-around__location">
        {neighborhoodTitle && (
          <h3 className="location-title uitk-type-heading-500" data-stid="whats-around-neighborhood">
            {neighborhoodTitle}
          </h3>
        )}
        {body && (
          <div className="location-editorial all-t-padding-three" data-stid="whats-around-editorial">
            <p className="uitk-type-paragraph-300 all-b-padding-three">{body}</p>
            <Viewport>
              <ViewSmall>
                <LinkToDX url={destinationPageLinkUrl} text={destinationPageLinkText} />
              </ViewSmall>
              <ViewMedium>
                <LinkToDX url={destinationPageLinkUrl} text={destinationPageLinkText} openNewTab={true} />
              </ViewMedium>
            </Viewport>
          </div>
        )}
      </UitkCardTextSegment>
    </React.Fragment>
  );
};

interface LinkToDXProps extends DestinationPageLink {
  openNewTab?: boolean;
}

const LinkToDX = ({ url, text, openNewTab }: LinkToDXProps) => {
  if (!url || !text) {
    return null;
  }

  const target = openNewTab && '_blank';

  return (
    <span className="uitk-flex all-y-margin-two">
      <TrackingLink linkName="WhatsAroundLinkDX" rfrr="LINK.DX" inline={true}>
        <a href={url} target={target} className="uitk-type-200 all-y-margin-three">
          {text}
        </a>
      </TrackingLink>
    </span>
  );
};
